import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ErrorReport } from '../../error-report';

@Component({
    selector: 'nom-reporter-dialog',
    templateUrl: './reporter-dialog.component.html',
    styleUrls: ['./reporter-dialog.component.scss'],
    standalone: false
})
export class ReporterDialogComponent {
  @Input()
  public reports!: ErrorReport[];

  @Input()
  public copyText: string | null = null;

  @Output()
  public dismissOne = new EventEmitter<ErrorReport>();

  @Output()
  public dismissAll = new EventEmitter();

  @Output()
  public copyAll = new EventEmitter();

  @Output()
  public copyAllHistory = new EventEmitter();

  @Output()
  public dismissCopy = new EventEmitter();

  public select(event: Event): void {
    const field = event.target as HTMLInputElement;
    field.select();
  }
}
